/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdateEmailBrandingRequest = {
    /**
     * Primary brand color (hex)
     */
    primaryColor?: string;
    /**
     * Secondary/background color (hex)
     */
    secondaryColor?: string;
    /**
     * Button corner style
     */
    buttonStyle?: UpdateEmailBrandingRequest.buttonStyle;
    /**
     * Show Tebuto branding in footer
     */
    showTebutoBranding?: boolean;
    /**
     * Global greeting text
     */
    greeting?: string;
    /**
     * Global farewell text
     */
    farewell?: string;
    /**
     * Footer title/practice name
     */
    footerTitle?: string;
    /**
     * Footer address
     */
    footerAddress?: string;
    /**
     * Footer phone number
     */
    footerPhone?: string;
    /**
     * Footer email address
     */
    footerEmail?: string;
    /**
     * Footer website URL
     */
    footerWebsite?: string;
};
export namespace UpdateEmailBrandingRequest {
    /**
     * Button corner style
     */
    export enum buttonStyle {
        ROUNDED = 'rounded',
        PILL = 'pill',
    }
}

